// react
import React from 'react'
import { createPortal } from 'react-dom'
import PropTypes from 'prop-types'

// components
import { Button } from '@st-operations/uikit/src/v2/index.js'

const bodySelector = document.querySelector('body')

const Calendar = React.forwardRef((props, ref) => {
  const {
    bottom,
    children,
    currentYear,
    hasArrows,
    isFirstYear,
    isLastYear,
    left,
    onNextYear,
    onPreviousYear,
  } = props

  return createPortal(
    <div style={{ bottom, left }} className="month-picker__calendar" ref={ref}>
      <div className="month-picker__header">
        <If condition={hasArrows && !isFirstYear}>
          <Button
            aria-label="Previous year"
            className="month-picker__arrow month-picker__arrow--left"
            disabled={isFirstYear}
            onClick={onPreviousYear}
          >
            <img
              alt="Arrow pointing to the left"
              src="../../../static/img/ic-arrowright-16-px.svg"
            />
          </Button>
        </If>
        <p className="month-picker__year">{currentYear}</p>
        <If condition={hasArrows && !isLastYear}>
          <Button
            aria-label="Next year"
            className="month-picker__arrow month-picker__arrow--right"
            disabled={isLastYear}
            onClick={onNextYear}
          >
            <img
              alt="Arrow pointing to the right"
              src="../../../static/img/ic-arrowright-16-px.svg"
            />
          </Button>
        </If>
      </div>
      <div className="month-picker__months">{children}</div>
    </div>,
    bodySelector
  )
})

Calendar.propTypes = {
  children: PropTypes.node.isRequired,
  currentYear: PropTypes.number,
  hasArrows: PropTypes.bool,
  isFirstYear: PropTypes.bool,
  isLastYear: PropTypes.bool,
  onNextYear: PropTypes.func,
  onPreviousYear: PropTypes.func,
  bottom: PropTypes.number.isRequired,
  left: PropTypes.number.isRequired,
}

Calendar.defaultProps = {
  currentYear: 0,
  hasArrows: false,
  isFirstYear: false,
  isLastYear: false,
  onNextYear: () => {},
  onPreviousYear: () => {},
}

Calendar.displayName = 'Calendar'

export default Calendar
